angular.module("rightPaneModule")
  .directive("trialBanner", function () {
    return {
      restrict: "E",
      templateUrl: '/resources/right-pane/components/trial-banner/trial-banner.directive.html',
      scope: {
        productPlanUrl: '=',
        childName: '=',
        daysLeft: '='
      }
    };
  });
